<section id="fees" class="py-5 bg-light" appScrollReveal>
  <div class="container">
    <h2 class="section-title">Fees & Preparation</h2>
    <div class="row g-4">
      <div class="col-md-6">
        <h5 class="fw-semibold">Consultation Fees</h5>
        <ul class="small mb-3">
          <li>First Visit: ₹500</li>
          <li>Follow-up (within 15 days): ₹300</li>
        </ul>
        <h6 class="fw-semibold">Payment Options</h6>
        <p class="small">UPI • Card • Cash</p>
      </div>
      <div class="col-md-6">
        <h5 class="fw-semibold">What to Bring</h5>
        <ul class="small mb-0">
          <li>Previous prescriptions</li>
          <li>Recent blood test / scan reports</li>
          <li>List of current medications</li>
          <li>Any discharge summary from past hospital visits</li>
        </ul>
      </div>
    </div>
  </div>
</section>
